import { useEffect, useState } from "react";
import { useGoBack } from "../utils";
import { useSelector } from "react-redux";
import { uploadMultipleFileImage } from "../apis/UploadImgApis";
import { AddEventsApis, GetMyEvents } from "../apis/EventsApis";
import { toast } from "react-toastify";
import { useDeviceLocation } from "./utilityHooks";
import { PaymentCreateIntentApi } from "../apis/PaymentApis";

export const useEventHooks = () => {
  //add events

  //all redux
  const places_redux = useSelector((s) => s?.allPlacesData);
  const { location } = useDeviceLocation(true);

  //all local states
  const [eventData, setEventData] = useState({});
  const [thankYouModalOpen, setThankYouModalOpen] = useState(false);
  const [placesDropDownData, setPlacesDropDownData] = useState([]);
  const [allMyEvents, setAllMyEvents] = useState([]);
  const [stripeModalOpen, setStripeModalOpen] = useState(false);
  const [clientSecret, setClientSecret] = useState(null);

  //all navigations
  const goBack = useGoBack();

  //all  useEffect
  useEffect(() => {
    if (places_redux?.length > 0) {
      setPlacesDropDownData(places_redux);
    }
  }, [places_redux]);


  useEffect(() => {
    GetMyEvents().then((r) => setAllMyEvents(r?.data?.data?.events??[]));
  }, [])


  //all functions
  const onPressPayBtn = () => {
    console.log("btn is pressed", eventData);

    const formData = new FormData();

    if (eventData?.photos?.length > 0) {
      eventData?.photos?.forEach((photo) => {
        formData.append("files", photo); // append File directly
      });
    }

    uploadMultipleFileImage(formData).then((res) => {
      if (res?.success) {
        let imgArray = res?.data?.files.map((e) => e.url);

        let payload = {
          photos: imgArray,
          categories: eventData?.categories,
          place: eventData?.place?.[0]?._id ?? null,
          types: eventData?.types,
          title: eventData?.title,
          reservationLink: eventData?.reservationLink,
          price: eventData?.price,
          startDate: eventData?.startDate,
          // endDate:eventData?.endDate,
          isSpecial: eventData?.isSpecial === "yes" ? true : false,
          genderPreference: [eventData?.genderPreference],
          description: eventData?.description,
          location: {
            streetAddress: eventData?.location?.streetAdress?.address,
            city: eventData?.location?.citySelected,
            stateProvince: eventData?.location?.stateSelected?.name,
            zipCode: eventData?.location?.zipCodeValue,
            country: eventData?.location?.countrySelectedName,
            coordinates: {
              lat: eventData?.location?.streetAdress?.lat ?? 0,
              lng: eventData?.location?.streetAdress?.lng ?? 0,
            },
          },
          geo: {
            type: "Point",
            coordinates: [
              eventData?.location?.stateSelected?.latitude ?? 0,
              eventData?.location?.stateSelected?.longitude ?? 0,
            ],
          },
          availability: eventData?.availability?.map(
            ({ checked, ...rest }) => rest
          ),
          discounts: eventData?.discounts,
        };
        console.log({ payload });
        AddEventsApis(payload).then((response) => {
          console.log("api resonse is", response);
          toast.success("Events Created Successfully");

          //integrate stripe sheet 

          let paymentPayload = {
            contentType: "event",
            contentId: response?.data?.data?.event?._id,
            amount: 5,
          };
          console.log("Event-payment creation payload,....",paymentPayload);
          
          PaymentCreateIntentApi(paymentPayload).then((res) => {
            console.log("response of intent is ==> ", res);
            if (res?.success) {
              const { clientSecret, customer, ephemeralKey } = res?.data;
              setClientSecret(clientSecret);
              setStripeModalOpen(true);
            }
          });
        });
      }
    });
  };
  return {
    //add events

    //all local states
    eventData,
    allMyEvents,
    setAllMyEvents,
    thankYouModalOpen,
    setThankYouModalOpen,
    setEventData,
    placesDropDownData,

    //all navigation
    goBack,

    //all functions
    onPressPayBtn,

//stripe
stripeModalOpen,
setStripeModalOpen,
clientSecret,
setClientSecret

  };
};
